<template>
    <v-dialog width="700px" v-model="dialog">

        <template v-slot:activator="{ on }">
            <v-btn
                    small
                    id="editModal"
                    class="float-right primary"
                    depressed
                    v-on="on"
            ><!--<v-icon left x-small>mdi-pencil</v-icon>-->Edit Details
            </v-btn>
        </template>

        <v-card>
            <v-card-title>
                <span class="headline">Edit Restaurant</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-tabs
                        v-model="tab_edit_restaurant"
                        background-color="grey lighten-4"
                        fixed-tabs
                        slider-color="grey darken-1"
                        style="margin-bottom:16px"
                    >
                        <v-tab>Main</v-tab>
                        <v-tab>Additional</v-tab>
                    </v-tabs>

                    <v-form ref="form">
                        <v-tabs-items v-model="tab_edit_restaurant">
                            <!-- tab 1 -->
                            <v-tab-item>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                                clear-icon="mdi-close"
                                                clearable
                                                outlined
                                                label="Restaurant Name*"
                                                hint="enter restaurant name"
                                                required
                                                v-model="name"
                                                :error-messages="nameErrors"
                                                @input="$v.name.$touch()"
                                                @blur="$v.name.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                                clear-icon="mdi-close"
                                                clearable
                                                outlined
                                                label="Contact Name*"
                                                hint="enter a contact name"
                                                v-model="contactName"
                                                :error-messages="contactNameErrors"
                                                required
                                                @input="$v.contactName.$touch()"
                                                @blur="$v.contactName.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                                clear-icon="mdi-close"
                                                clearable
                                                outlined
                                                label="Address*"
                                                hint="if manual input is required"
                                                v-model="address"
                                                persistent-hint
                                                required
                                                :error-messages="addressErrors"
                                                @input="$v.address.$touch()"
                                                @blur="$v.address.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <!-- <v-col cols="12" sm="5" md="3">
                                        <v-text-field
                                                clear-icon="mdi-close"
                                                clearable
                                                outlined
                                                label="Postcode"
                                                hint="Enter postcode"
                                                v-model="postcode"
                                        ></v-text-field>
                                    </v-col> -->

                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                                clear-icon="mdi-close"
                                                clearable
                                                outlined
                                                label="Restaurant Email*"
                                                required
                                                v-model="email"
                                                :error-messages="emailErrors"
                                                disabled
                                                @input="$v.email.$touch()"
                                                @blur="$v.email.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                                clear-icon="mdi-close"
                                                clearable
                                                outlined
                                                label="Telephone Number*"
                                                type="Telephone"
                                                v-model="telephone"
                                                required
                                                :error-messages="telephoneErrors"
                                                @change="$v.telephone.$touch()"
                                                @blur="$v.telephone.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-switch v-model="switch_change_password" :label="`Change Password`"></v-switch>
                                    </v-col>

                                    <v-col cols="12" sm="12" v-if="switch_change_password">
                                        <v-text-field
                                                :append-icon="showPasswordCurrent ? 'mdi-eye' : 'mdi-eye-off'"
                                                :type="showPasswordCurrent ? 'text' : 'password'"
                                                @click:append="showPasswordCurrent = !showPasswordCurrent"
                                                clear-icon="mdi-close"
                                                clearable
                                                outlined
                                                label="Current Password"
                                                v-model="current_password"
                                                :error-messages="currentPasswordErrors"
                                                :counter="12"
                                                @change="$v.current_password.$touch()"
                                                @blur="$v.current_password.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" v-if="switch_change_password">
                                        <v-text-field
                                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                :type="showPassword ? 'text' : 'password'"
                                                @click:append="showPassword = !showPassword"
                                                clear-icon="mdi-close"
                                                clearable
                                                outlined
                                                name="password"
                                                label="Password"
                                                v-model="password"
                                                :rules="passwordRules"
                                                :counter="12"
                                        ></v-text-field>
                                    </v-col>

                                </v-row>
                            </v-tab-item>
                            <!--/ tab 1 -->
                            <!-- tab 2 -->
                            <v-tab-item>
                                <v-row>
                                    <v-col cols="12" sm="12">
                                        <v-file-input
                                            :rules="imgRules"
                                            accept="image/png, image/jpeg, image/jpg, image/bmp"
                                            placeholder="Upload a file"
                                            prepend-icon="mdi-camera"
                                            label="File"
                                            ref="image"
                                            @change="onChangeFileUpload"
                                        ></v-file-input>
                                        <v-img
                                            max-width="500px"
                                            max-height="300px"
                                            v-model="logo_src"
                                            v-if="logo_src"
                                            :src="`${appConfig.app_url}/images/${logo_src}`"
                                        ></v-img>
                                        <v-btn v-if="logo_src" color="error" text @click="onRemoveLogo()">
                                            <v-icon left>mdi-close</v-icon>Remove Logo
                                        </v-btn>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Meal"
                                            hint="enter meal"
                                            v-model="meal"
                                            :error-messages="mealErrors"
                                            @input="$v.meal.$touch()"
                                            @blur="$v.meal.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Uniform"
                                            hint="enter uniform"
                                            v-model="uniform"
                                            :error-messages="uniformErrors"
                                            required
                                            @input="$v.uniform.$touch()"
                                            @blur="$v.uniform.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Cash Orders"
                                            hint="enter cash orders"
                                            v-model="cash_orders"
                                            :error-messages="cash_ordersErrors"
                                            required
                                            @input="$v.cash_orders.$touch()"
                                            @blur="$v.cash_orders.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Waiting location"
                                            hint="enter waiting location"
                                            v-model="waiting_location"
                                            :error-messages="waiting_locationErrors"
                                            required
                                            @input="$v.waiting_location.$touch()"
                                            @blur="$v.waiting_location.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Other"
                                            hint="enter other"
                                            v-model="other"
                                            :error-messages="otherErrors"
                                            required
                                            @input="$v.other.$touch()"
                                            @blur="$v.other.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Bonus Target"
                                            hint="enter Bonus Target"
                                            v-model="bonus_target"
                                            :error-messages="bonus_targetErrors"
                                            required
                                            @input="$v.bonus_target.$touch()"
                                            @blur="$v.bonus_target.$touch()"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12"  v-if="service_agreement_src" style="padding-top: 0px!important;padding-bottom: 18px!important;">
                                        <h3>Service Agreement (click URL to download)</h3>
                                        <a :href="`${appConfig.app_url}/documents/service_agreements/restaurant/${service_agreement_src}`" target="_blank" download>{{service_agreement_src}}</a>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!--/ tab 2 -->
                        </v-tabs-items>
                        <div class="d-flex justify-center">
                            <v-btn
                                    depressed
                                    class="mr-4 primary"
                                    :disabled="this.$v.$invalid || localLoading"
                                    @click="submit"
                                    :loading="localLoading"
                            >
                                <v-icon left>mdi-check-box-outline</v-icon>
                                Accept Changes
                            </v-btn>
                            <v-btn
                                    class="warning"
                                    depressed
                                    @click="cancel"
                                    :loading="localLoading"
                            >
                                <v-icon left>mdi-cancel</v-icon>
                                Cancel
                            </v-btn>
                        </div>

                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, /*maxLength, numeric, */email} from 'vuelidate/lib/validators'
    import axios from '@/utils/request'
    import * as _ from 'lodash'

    export default {
        mixins: [validationMixin],
        name: "NewLocationModal",
        props: ['thisRestaurantData'],
        validations: {
            name: {required,/* maxLength: maxLength(10)*/},
            email: {required, email},
            telephone: {required, /*numeric*/},
            contactName: {required},
            // area: {required},
            address: {required},
            current_password: {},
            meal: {},
            uniform: {},
            cash_orders: {},
            waiting_location: {},
            other: {},
            bonus_target: {},
        },
        data: () => ({
            switch_change_password: false,
            showPasswordCurrent: false,
            showPassword: false,
            passwordRules: [
                v => !!v || 'Please enter your password',
                v => (v && v.length >= 6) || 'Password should be at least six symbols long'
            ],
            current_password: '',
            password: '',
            /*valid: false,*/
            restaurantData: null,
            localLoading: false,
            dialog: false,
            id: '',
            name: '',
            email: '',
            address: '',
            contactName: '',
            telephone: '',
            postcode: '',
            tab_edit_restaurant: void 0,
            // tab2 fields:
            meal: void 0,
            uniform: void 0,
            cash_orders: void 0,
            waiting_location: void 0,
            other: void 0,
            bonus_target: void 0,
            file: void 0,
            imgRules: [
                value => {
                    if (value && value.size > 10000000) {
                        return 'File size should be less than 10 MB!';
                    }
                    return true;
                }
            ],
            logo_src: void 0,
            service_agreement_src: void 0
        }),
        created() {
            // --
        },
        mounted() {
            this.restaurantData = this.thisRestaurantData;
            this.id = this.thisRestaurantData.id;
            this.name = this.thisRestaurantData.name;
            this.email = this.thisRestaurantData.email;
            this.address = this.thisRestaurantData.address;
            this.contactName = this.thisRestaurantData.contactName;
            this.telephone = this.thisRestaurantData.telephone;
            this.postcode = this.thisRestaurantData.postcode;

            this.meal = this.thisRestaurantData.meal;
            this.uniform = this.thisRestaurantData.uniform;
            this.cash_orders = this.thisRestaurantData.cash_orders;
            this.waiting_location = this.thisRestaurantData.waiting_location;
            this.other = this.thisRestaurantData.other;
            this.bonus_target = this.thisRestaurantData.bonus_target;
            this.logo_src = this.thisRestaurantData.logo_src;
            this.service_agreement_src = this.thisRestaurantData.service_agreement_src;
        },
        computed: {
            nameErrors() {
                const errors = []
                if (!this.$v.name.$dirty) return errors
                /*!this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')*/
                !this.$v.name.required && errors.push('Restaurant name is required.')
                return errors
            },
            contactNameErrors() {
                const errors = []
                if (!this.$v.contactName.$dirty) return errors
                !this.$v.contactName.required && errors.push('Contact Name is required.')
                return errors
            },
            emailErrors() {
                const errors = []
                if (!this.$v.email.$dirty) return errors
                !this.$v.email.email && errors.push('Must be valid e-mail')
                !this.$v.email.required && errors.push('E-mail is required')
                return errors
            },
            addressErrors() {
                const errors = []
                if (!this.$v.address.$dirty) return errors
                !this.$v.address.required && errors.push('Address is required')
                return errors
            },
            telephoneErrors() {
                const errors = []
                if (!this.$v.telephone.$dirty) return errors
                !this.$v.telephone.required && errors.push('Telephone number is required')
                return errors
            },
            currentPasswordErrors() {
                const errors = []
                if (!this.$v.current_password.$dirty) return errors
                // !this.$v.current_password.required && errors.push('Please enter your password')
                return errors
            },
            mealErrors() {
                const errors = []
                if (!this.$v.meal.$dirty) return errors
                // !this.$v.meal.required && errors.push('Meal is required.')
                return errors
            },
            uniformErrors() {
                const errors = []
                if (!this.$v.uniform.$dirty) return errors
                // !this.$v.uniform.required && errors.push('Uniform is required.')
                return errors
            },
            cash_ordersErrors() {
                const errors = []
                if (!this.$v.cash_orders.$dirty) return errors
                // !this.$v.cash_orders.required && errors.push('Cash Orders is required.')
                return errors
            },
            waiting_locationErrors() {
                const errors = []
                if (!this.$v.waiting_location.$dirty) return errors
                // !this.$v.waiting_location.required && errors.push('Waiting location is required.')
                return errors
            },
            otherErrors() {
                const errors = []
                if (!this.$v.other.$dirty) return errors
                // !this.$v.other.required && errors.push('Other is required.')
                return errors
            },
            bonus_targetErrors() {
                const errors = []
                if (!this.$v.bonus_target.$dirty) return errors
                // !this.$v.bonus_target.required && errors.push('Bonus Target is required.')
                return errors
            },
        },


        methods: {
            onChangeFileUpload(file){
                this.file = file;
            },
            onRemoveLogo() {
                this.logo_src = void 0;
            },
            cancel() {
                this.restaurantData = this.thisRestaurantData
                this.name = this.thisRestaurantData.name
                this.email = this.thisRestaurantData.email
                this.address = this.thisRestaurantData.address
                this.contactName = this.thisRestaurantData.contactName
                this.telephone = this.thisRestaurantData.telephone
                this.postcode = this.thisRestaurantData.postcode

                this.meal = this.thisRestaurantData.meal;
                this.uniform = this.thisRestaurantData.uniform;
                this.cash_orders = this.thisRestaurantData.cash_orders;
                this.waiting_location = this.thisRestaurantData.waiting_location;
                this.other = this.thisRestaurantData.other;
                this.bonus_target = this.thisRestaurantData.bonus_target;
                this.logo_src = this.thisRestaurantData.logo_src;
                this.file = void 0;

                this.dialog = false;
            },
            submit() {
                let user = JSON.parse(localStorage.getItem("user"));
                this.localLoading = true
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    let editedRestaurant = {
                        id: this.id,
                        name: this.name,
                        // email: this.email,
                        address: this.address,
                        contactName: this.contactName,
                        telephone: this.telephone,
                        postcode: this.postcode,
                        current_password: this.current_password,
                        meal: this.meal,
                        uniform: this.uniform,
                        cash_orders: this.cash_orders,
                        waiting_location: this.waiting_location,
                        other: this.other,
                        bonus_target: this.bonus_target,
                        logo_src: this.logo_src ? this.logo_src : null,
                    }

                    if (this.switch_change_password) {
                        editedRestaurant.password = this.password;
                    }

                    // send file
                    let formData = new FormData();
                    formData.append('file', this.file);

                    _.each(editedRestaurant, (val, key) => {
                        formData.append(key, val);
                    });

                    formData.append('_method', 'PATCH'); //! put not working on FormData, -> use PATCH && post
                    axios.post(`${this.appConfig.app_url}/api/restaurant/profile/${this.id}`, formData, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        },
                    })
                        .then(result => {
                            this.dialog = false;

                            // upgrade info in localStorage
                            if (localStorage.getItem("user")) {
                                let user_item = JSON.parse(localStorage.getItem("user"));
                                
                                let restaurants = [];
                                _.each(user_item.restaurants, restaurant => {
                                    let restaurant_item = {
                                        id: restaurant.id,
                                        area_id: restaurant.area_id,
                                        name: restaurant.name,
                                        address: restaurant.address,
                                        contact_name: restaurant.contact_name,
                                        telephone: restaurant.telephone,
                                        map_latitude: restaurant.map_latitude,
                                        map_longitude: restaurant.map_longitude,
                                        meal: restaurant.meal,
                                        uniform: restaurant.uniform,
                                        cash_orders: restaurant.cash_orders,
                                        waiting_location: restaurant.waiting_location,
                                        other: restaurant.other,
                                        bonus_target: restaurant.bonus_target,
                                        logo_src: restaurant.logo_src,
                                        service_agreement_src: restaurant.service_agreement_src,
                                        // email: user_item.email
                                    };

                                    // refresh data
                                    if (restaurant.id == result.data.id) {
                                        // restaurant_item.id = result.data.id;
                                        restaurant_item.area_id = result.data.area_id;
                                        restaurant_item.name = result.data.name;
                                        restaurant_item.address = result.data.address;
                                        restaurant_item.contact_name = result.data.contact_name;
                                        restaurant_item.telephone = result.data.telephone;
                                        restaurant_item.map_latitude = result.data.map_latitude;
                                        restaurant_item.map_longitude = result.data.map_longitude;
                                        restaurant_item.meal = result.data.meal;
                                        restaurant_item.uniform = result.data.uniform;
                                        restaurant_item.cash_orders = result.data.cash_orders;
                                        restaurant_item.waiting_location = result.data.waiting_location;
                                        restaurant_item.other = result.data.other;
                                        restaurant_item.bonus_target = result.data.bonus_target;
                                        restaurant_item.logo_src = result.data.logo_src;
                                        restaurant_item.service_agreement_src = result.data.service_agreement_src;
                                    }

                                    restaurants.push(restaurant_item);
                                });

                                user_item.restaurants = restaurants;

                                this.$store.commit('setUser', user_item);
                                localStorage.setItem("user", JSON.stringify(user_item));
                                this.cancel(); // reset image
                            }
                        }).then(() => {
                            this.$emit('updated', '');
                            this.current_password = '';
                            this.password = '';
                            this.switch_change_password = false;
                            this.$v.$reset();
                        })
                        .catch(error => {
                            this.current_password = '';

                            if (error.response) {
                                let errors = error.response;
                                if (errors.status == 401) {
                                    this.$store.dispatch('logOutUser');
                                    window.location.reload();
                                }

                                if (errors.status == 400) {
                                    this.$store.dispatch('setError', _.values(errors.data)[0][0]);
                                    return errors.data;
                                }
                            }

                            this.$store.dispatch('setError', 'Unknown error');
                        }).finally(() => {
                            this.localLoading = false;
                        })
                }
            },
        },
    }
</script>

<style scoped>

</style>